import 'css-chunksrc/client/common/secondaryCriteriaForm/textForm/styles.scss';export default {
  "textForm": "_textForm_k1zu6_1",
  "input": "_input_k1zu6_5",
  "multiline": "_multiline_k1zu6_12",
  "readOnly": "_readOnly_k1zu6_17",
  "disabled": "_disabled_k1zu6_23"
};